import { Link, useNavigate, useParams } from "react-router-dom";
import { useMemo } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { TopicHeader } from "../TopicHeader";
import useQueryString from "../../../utils/hooks/useQueryString";
import { scrollToElement } from "../../../lib/userFunctions";
import { Loading } from "../../components/Loading";
import { Pagination } from "../../components/Pagination";
import { StoryListItem } from "./StoryListItem";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";


export const StoryList = ({path=null, forcedData={}}) => {
    const navigate = useNavigate();
    const { school, topicId } = useParams();
    const queryParams = useQueryString();

    const requestData = useMemo(() => {
        let paramJson = { page: 0, sort: 'id,desc', bestYn: 'N', user: 'N', topicId };
        paramJson = { ...paramJson, ...queryParams };
        if (Number.isNaN(paramJson.page)) paramJson.page = 0;
        if (!_.includes(['id,desc', 'readCount,desc', 'likeCount,desc'], paramJson.sort)) paramJson.sort = 'id,desc';
        return paramJson;
    }, [queryParams, topicId]);

    const { data: storyList, isFetching, isError, error } = useQuery({
        queryKey: ['donghwa/topic/stories', requestData],
        queryFn: () => Api.post(`/api/dongwha/story/list?page=${requestData.page}&sort=${requestData.sort}&size=${requestData.size}`, requestData),
        placeholderData: keepPreviousData
    });

    const fetchList = (page) => {
        let tempSearchOption = { ...queryParams, page };
        scrollToElement('storyList');
        navigate({pathname:path || `/${school}/donghwa/${topicId}`, search:`${queryString.stringify(tempSearchOption)}`});
    };

    const listTitle = useMemo(() => {
        if (requestData.bestYn === "Y") return <p className="desc"> 친구들의 <span>장원급제 작품들</span>을 만나보아요.</p>;
        if (requestData.user === 'Y') return <p className="desc">나의 <span>작품</span>을 만나보아요.</p>;
        return <p className="desc">친구들의 <span>이야기</span>를 만나보아요.</p>;
    }, [requestData]);

    const list = useMemo(() => {
        if (isError) return <div className="no_data">{createFetchErrorMessage(error).message}</div>
        if (storyList?.data?.list.length <= 0) return <div className="no_data"><p>이야기가 없습니다.</p></div>;
        return storyList?.data?.list.map((story) => <StoryListItem story={story} key={story.id} />);
    }, [storyList, isError, error]);


    return (
        <>
            <TopicHeader />
            <div className="storyList contents" id="storyList">
                <div className="hdline side">
                    {listTitle}
                    <ul className="sorts">
                        <li><Link to={`/${school}/donghwa/${topicId}?${queryString.stringify({...requestData, page:0, sort:'id,desc'})}`} className={`${queryParams.sort === undefined || queryParams.sort === 'id,desc' ? 'active' : ''}`}>최신순</Link></li>
                        {/* <li><Link to={`/${school}/donghwa/${topicId}?${queryString.stringify({...requestData, page:0, sort:'readCount,desc'})}`} className={`${queryParams.sort === 'readCount,desc' ? 'active' : ''}`}>조회순</Link></li> */}
                        <li><Link to={`/${school}/donghwa/${topicId}?${queryString.stringify({...requestData, page:0, sort:'likeCount,desc'})}`} className={`${queryParams.sort === 'likeCount,desc' ? 'active' : ''}`}>좋아요순</Link></li>
                    </ul>
                </div>
                <ul className={`list ${storyList?.data?.list <= 0 ? 'no_list' : ''}`}>
                    {list}
                    <Loading overlay={true} active={isFetching} />
                </ul>
                <Pagination page={storyList?.data?.page || 0} totalPage={storyList?.data?.totalPages || 1} gotoPage={fetchList} />
            </div>
        </>
    );
};